module.exports = __webpack_public_path__ + "img/Large-Bevel-Attachment-45.112cf4c4.png";